import { useSelector } from '@common/performance/useSelector';
import { GemSpec, CommonState } from '@common/types';
import { StableChildren } from '@prophecy/utils/react/StableChildren';
import { createContext, useContext } from 'react';

type SpecGetter<S extends CommonState> = (state: S) => GemSpec[];

const GemSpecContext = createContext<<S extends CommonState>(state: S) => GemSpec[]>((s) => s.gemSpecs);

export function useSpecs<S extends CommonState = CommonState>(): GemSpec[] {
  const getter = useContext(GemSpecContext);
  return useSelector<S, GemSpec[]>((state) => getter(state));
}
export function GemSpecProvider<S extends CommonState>({
  children,
  getGemSpec
}: {
  children: React.ReactNode;
  getGemSpec: SpecGetter<S>;
}) {
  return (
    <GemSpecContext.Provider value={getGemSpec as SpecGetter<CommonState>}>
      <StableChildren>{children}</StableChildren>
    </GemSpecContext.Provider>
  );
}
